import {getMediaUrl} from '@/shared/lib/getMediaUrl';

export const LOGIN_CARD = [
  {
    image: getMediaUrl('landing/single.webp'),
    title: '70% of users are looking for serious relationship',
    description:
      'Join a community where the majority of members are seeking meaningful and long-lasting connections.',
  },
  {
    image: getMediaUrl('landing/ver.webp'),
    title: '87% of users are photo-verified',
    description:
      'We ensure a safer and more authentic experience to help you build genuine relationships.',
  },
  {
    image: getMediaUrl('landing/girl.webp'),
    title: '60% of users are women',
    description:
      'This creates an inclusive environment, increasing your chances of finding someone who matches your preferences.',
  },
];
